import React from 'react';
import PropTypes from 'prop-types';

import Product from './Product';

import styles from './index.scss';

const ProductsList = ({ products, translationsMap }) => (
    <div className={styles.products}>
        <div className={styles.products__title}>{translationsMap['searchBox.inProducts']}</div>
        <ul className={styles.products__list}>
            {products.map((product, index) => (
                <Product
                    key={`${index}-${product.sku}`}
                    product={product}
                    translationsMap={translationsMap}
                />
            ))}
        </ul>
    </div>
);

ProductsList.propTypes = {
    products: PropTypes.array.isRequired,
    translationsMap: PropTypes.object.isRequired,
};

export default ProductsList;
